var basePath = '/images/makes';
var blankImage = "".concat(basePath, "/blank.png");
var makePhotoUrls = {
  'acura': "".concat(basePath, "/acura.png"),
  'alfa-romeo': "".concat(basePath, "/alfa-romeo.png"),
  'alpine': "".concat(basePath, "/alpine.png"),
  'american motors': "".concat(basePath, "/american-motors.png"),
  'aston martin': "".concat(basePath, "/aston-martin.png"),
  'audi': "".concat(basePath, "/audi.png"),
  'bentley': "".concat(basePath, "/bentley.png"),
  'bmw': "".concat(basePath, "/bmw.png"),
  'bricklin': "".concat(basePath, "/bricklin.png"),
  'british motor corporation': "".concat(basePath, "/british-motor-corporation.png"),
  'buick': "".concat(basePath, "/buick.png"),
  'cadillac': "".concat(basePath, "/cadillac.png"),
  'chevrolet': "".concat(basePath, "/chevrolet.png"),
  'chrysler': "".concat(basePath, "/chrysler.png"),
  'citroen': "".concat(basePath, "/citroen.png"),
  'daewoo': "".concat(basePath, "/daewoo.png"),
  'daihatsu': "".concat(basePath, "/daihatsu.png"),
  'delorean': "".concat(basePath, "/delorean.png"),
  'dodge/plymouth': "".concat(basePath, "/dodge-plymouth.png"),
  'dodge': "".concat(basePath, "/dodge.png"),
  'eagle': "".concat(basePath, "/eagle.png"),
  'etoile': "".concat(basePath, "/etoile.png"),
  'ferrari': "".concat(basePath, "/ferrari.png"),
  'fiat': "".concat(basePath, "/fiat.png"),
  'ford': "".concat(basePath, "/ford.png"),
  'geo': "".concat(basePath, "/geo.png"),
  'gmc': "".concat(basePath, "/gmc.png"),
  'honda': "".concat(basePath, "/honda.png"),
  'hyundai': "".concat(basePath, "/hyundai.png"),
  'infiniti': "".concat(basePath, "/infiniti.png"),
  'international harvester': "".concat(basePath, "/international-harvester.png"),
  'isuzu': "".concat(basePath, "/isuzu.png"),
  'jaguar': "".concat(basePath, "/jaguar.png"),
  'jeep': "".concat(basePath, "/jeep.png"),
  'jensen motors': "".concat(basePath, "/jensen-motors.png"),
  'kia': "".concat(basePath, "/kia.png"),
  'lada': "".concat(basePath, "/lada.png"),
  'lamborghini': "".concat(basePath, "/lamborghini.png"),
  'land rover': "".concat(basePath, "/land-rover.png"),
  'lexus': "".concat(basePath, "/lexus.png"),
  'lincoln': "".concat(basePath, "/lincoln.png"),
  'lotus': "".concat(basePath, "/lotus.png"),
  'maserati': "".concat(basePath, "/maserati.png"),
  'maybach': "".concat(basePath, "/maybach.png"),
  'mazda': "".concat(basePath, "/mazda.png"),
  'mercedes-benz': "".concat(basePath, "/mercedes-benz.png"),
  'mercury': "".concat(basePath, "/mercury.png"),
  'mg': "".concat(basePath, "/mg.png"),
  'mitsubishi': "".concat(basePath, "/mitsubishi.png"),
  'nash': "".concat(basePath, "/nash.png"),
  'nissan': "".concat(basePath, "/nissan.png"),
  'nuova innocenti': "".concat(basePath, "/nuova-innocenti.png"),
  'oldsmobile': "".concat(basePath, "/oldsmobile.png"),
  'opel': "".concat(basePath, "/opel.png"),
  'peugeot': "".concat(basePath, "/peugeot.png"),
  'plymouth': "".concat(basePath, "/plymouth.png"),
  'pontiac': "".concat(basePath, "/pontiac.png"),
  'porsche': "".concat(basePath, "/porsche.png"),
  'renault': "".concat(basePath, "/renault.png"),
  'rolls-royce': "".concat(basePath, "/rolls-royce.png"),
  'saab': "".concat(basePath, "/saab.png"),
  'saturn': "".concat(basePath, "/saturn.png"),
  'scion': "".concat(basePath, "/scion.png"),
  'skoda': "".concat(basePath, "/skoda.png"),
  'smart': "".concat(basePath, "/smart.png"),
  'studebaker': "".concat(basePath, "/studebaker.png"),
  'subaru': "".concat(basePath, "/subaru.png"),
  'sunbeam': "".concat(basePath, "/sunbeam.png"),
  'suzuki': "".concat(basePath, "/suzuki.png"),
  'tesla': "".concat(basePath, "/tesla.png"),
  'toyota': "".concat(basePath, "/toyota.png"),
  'triumph': "".concat(basePath, "/triumph.png"),
  'tvr': "".concat(basePath, "/tvr.png"),
  'volkswagen': "".concat(basePath, "/volkswagen.png"),
  'volvo': "".concat(basePath, "/volvo.png"),
  'yugo': "".concat(basePath, "/yugo.png")
};
export var getMakePhotoUrl = function getMakePhotoUrl(make) {
  return (makePhotoUrls === null || makePhotoUrls === void 0 ? void 0 : makePhotoUrls[make.toLowerCase()]) || blankImage;
};